import { render, staticRenderFns } from "./FormAssetVideo.vue?vue&type=template&id=32d426c0&scoped=true&lang=pug"
import script from "./FormAssetVideo.vue?vue&type=script&lang=js"
export * from "./FormAssetVideo.vue?vue&type=script&lang=js"
import style0 from "./FormAssetVideo.vue?vue&type=style&index=0&id=32d426c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d426c0",
  null
  
)

export default component.exports